import smoothScroll from '@argos/utils/esnext/smooth-scroll'

function scrollToTop (hijackFocus = true) {
  smoothScroll.scrollHere(document.body, 0, 300)
  if (hijackFocus) document.querySelector('#helpfaqcontent').focus()
}

export default scrollToTop
